<template>
  <div class="leadViwport">
    <div
      class="leaderList"
      v-for="(data, index) in leaderBoardViewportList"
      v-if="leaderBoardViewportList.length > 0"
      :key="index"
    >
      <div class="titleText titleText_1">
        <span class="posText">{{ `0${++index}` }}</span>
      </div>
      <div class="titleText titleText_2">
        <img src="../../src/assets/images/avtar.jpg" class="profileIcon" /><span
          class="userTitleText"
          >{{ data.name }}
        </span>
      </div>
      <div class="titleText titleText_3">
        {{ ConvertSecondsTohours(data.total_duration) }}
      </div>
      <div class="titleText titleText_4">
        <img
          src="../../src/assets/images/rupees_icon.png"
          class="rupeesIcon"
        />{{ data.leader_board_score }}
      </div>
    </div>
    <infinite-loading
      v-if="this.$route.name !== 'leaderBoardWinnerList'"
      @infinite="infiniteHandler"
    >
      <template slot="no-more"
        >और रिकॉर्ड उपलब्ध नहीं है</template
      >
    </infinite-loading>
  </div>
</template>

<script>
import { ConvertSecondsTohours } from '../utils/helper'
import { BASE_API_URL, LOCAL_URL } from '../utils/constant'
import InfiniteLoading from 'vue-infinite-loading'
import Vue from 'vue'
Vue.use(InfiniteLoading)

export default {
  name: 'leaderBoardViewport',
  components: {
    InfiniteLoading
  },
  props: [
    'xAuthIdUser',
    'leaderBoardViewportList',
    'DD',
    'MM',
    'weekMonthLeaderboard'
  ],
  data() {
    return {
      page: 1
    }
  },
  methods: {
    ConvertSecondsTohours,
    infiniteHandler($state) {
      console.log(
        '=-this.weekMonthLeaderboard=this.weekMonthLeaderboard=',
        this.weekMonthLeaderboard
      )
      this.$http
        .get(
          `${LOCAL_URL}/weekly_and_monthly_leader_board?page_no=1&category=${this.weekMonthLeaderboard}`
        )
        .then(({ data }) => {
          console.log('=-=data----data=', data.data.data)
          if (data.data.length) {
            this.page += 1
            this.leaderBoardViewportList.push(...data.data.data)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    }
  },
  sockets: {},
  mounted() {
    this.DD = new Date().getDate()
    this.MM = new Date().getUTCMonth() + 1
  }
}
</script>
